<template>
  <div class="ymf-wrapper">
    <FoldNav></FoldNav>
    <div class="focus-wrap">
      <img class="focus-img" v-if="showFocusImage"
        src="https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/h5_video0181.jpg" width="100%" height="100%"
        alt="">
      <video v-else-if="$isMobile" class="focus-video" height="100%" preload="metadata" x-webkit-airplay="true"
        x5-video-player-type="h5" x5-video-player-fullscreen="true" x5-video-orientation="portraint" playsinline="true"
        webkit-playsinline="true" x5-playsinline hw-playsinline muted :src="videoSrc"
        poster="https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/poster.jpg" />
      <video v-else class="focus-video" height="100%" muted preload
        poster="https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/poster.jpg">
        <source :src="videoSrc">
      </video>
      <transition name="fadeIn" :duration="500">
        <div v-show="isVideoEnd">
          <span class="t-scroll"></span>
        </div>
      </transition>
      <div class="ymf-text">
        <h2>怡满分官方网站</h2>
        <p><b>煮自然的鲜</b></p>
        <p><b>熬生活的甜</b></p>
        <p><b>手作古法糖水</b></p>
      </div>
    </div>
    <div class="new-product">
      <div class="out-swiper-wraper">
        <div class="swiper new-product-swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in newProducts" :key="index">
              <img :src="item.pic" width="100%" alt="古法糖水">
            </div>
          </div>
          <div class="swiper-pagination">
            <span v-for="n in newProducts.length" :key="n" :class="n === currentIndex + 1 ? 'active' : ''"></span>
          </div>
          <div class="swiper-button-prev" @click="prevSlide"></div>
          <div class="swiper-button-next" @click="nextSlide"></div>

        </div>
      </div>
    </div>
    <div class="liaojie">
      <video v-if="$isMobile" class="bg-video" height="100%" preload="metadata" x-webkit-airplay="true"
        x5-video-player-type="h5" x5-video-player-fullscreen="true" x5-video-orientation="portraint" playsinline="true"
        webkit-playsinline="true" muted :src="videoBgSrc" hw-playsinline loop x5-playsinline />
      <video v-else class="bg-video" height="100%" muted autoplay loop>
        <source :src="videoBgSrc">
      </video>
      <div class="md-container">
        <div class="text-wrapper">
          <div class="ymf-text">
            <h6>怡满分</h6>
            <p>
              怡满分诞生于2024年，是一家专注于糖水的甜品品牌。品牌以东方生活哲学为灵感，将传统甜品与自然美学相融合，坚持“回归本源，追求纯粹”的理念，在制作过程中去除一切不必要的修饰，还原食物最本质的味道和美感。精选新鲜食材，原野原味，力求为顾客呈现来自世界各地的纯净风味，让每一位顾客都能在品尝中感受到大自然的质朴气息。我们所追求的，是恰到好处的甜味以及为用户带来满分的快乐。
            </p>
          </div>
        </div>
        <a href="/brand_story" target="_blank" title="了解我们"></a>
      </div>
    </div>

    <div class="huiyi-wrapper">
      <div class="huiyi">
        <div class="md-container">
          <span class="left-text"></span>
          <b></b>
        </div>
        <span class="right-text"></span>
        <div class="ymf-text">
          <p>回到大众记忆最初的味道</p>
          <p><b>回归本源</b><b>遵循本味</b><b>找寻本真</b></p>
        </div>
        <img v-if="$isMobile"
          src="https://outin-659b005a2fad11f083ad00163e1c94a4.oss-cn-shanghai.aliyuncs.com/image/default/B34C447A503748A9B8E92A39CC26EF16-6-2.jpg"
          width="100%" alt="怡满分,古法糖水,店铺加盟,店铺合伙人">
        <template v-else>
          <img src="https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/fenwei_01.jpg" width="100%"
            alt="怡满分,古法糖水,店铺加盟,店铺合伙人">
          <img src="https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/fenwei_02.jpg" width="100%"
            alt="怡满分,古法糖水,店铺加盟,店铺合伙人">
          <img src="https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/fenwei_03.jpg" width="100%"
            alt="怡满分,古法糖水,店铺加盟,店铺合伙人">
          <img src="https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/fenwei_04.jpg" width="100%"
            alt="怡满分,古法糖水,店铺加盟,店铺合伙人">
        </template>
      </div>
    </div>

    <div class="more-product">
      <div class="more-swiper-wraper">
        <div class="swiper more-product-swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in moreProducts" :key="index">
              <img :src="item.pic" width="100%" height="auto" alt="古法糖水">
            </div>

          </div>
          <div class="swiper-pagination" v-if="$isMobile">
            <span v-for="n in slideLength" :key="n" :class="n === currentIndex2 + 1 ? 'active' : ''"></span>
          </div>
          <div class="product-swiper-button-prev" @click="prevSlide2"></div>
          <div class="product-swiper-button-next" @click="nextSlide2"></div>
          <div class="ymf-text">
            <h6>满分大满贯</h6>
            <h6>银耳桃胶大满贯</h6>
            <h6>香芋椰汁西米露</h6>
            <h6>芒果雪糯</h6>
            <h6>杨枝金捞</h6>
            <h6>龙眼冰</h6>
            <h6>豆花大满贯</h6>
            <h6>酒酿豆花</h6>
            <h6>芒果布丁豆花冰</h6>
          </div>
        </div>
      </div>
      <a href="/product" target="_blank" class="go-more-product"></a>
    </div>

    <div class="info">
      <div class="md-container">
        <div class="info-box">
          <h3>品牌资讯</h3>
          <span class="t-line"></span>
          <ul class="info-list">
            <li v-for="(item, index) in infoList" :key="index">
              <a :href="item.link" target="_blank" :title="item.title">
                <span class="til"> {{ item.title }} </span>
                <span class="info-date"> {{ item.date }} </span>
              </a>
            </li>

          </ul>
          <span class="t-line"></span>
          <a href="/brand_info" target="_blank" class="more-btn"></a>
        </div>

      </div>
      <img v-if="$isMobile"
        src="https://outin-659b005a2fad11f083ad00163e1c94a4.oss-cn-shanghai.aliyuncs.com/image/default/250580776C5B40DD9CC9B78591E45895-6-2.jpg"
        width="100%" alt="">
      <template v-else>
        <img src="https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/2025.03.063372-1_01.jpg" width="100%" alt="">
        <img src="https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/2025.03.063372-1_02.jpg" width="100%" alt="">
        <img src="https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/2025.03.063372-1_03.jpg" width="100%" alt="">
        <img src="https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/2025.03.063372-1_04.jpg" width="100%" alt="">
      </template>
    </div>

    <div class="store">
      <h3>门店分布</h3>
      <div class="store-swiper-wraper">
        <div class="swiper store-swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in storeList" :key="index">
              <img :src="item.pic" width="100%" height="auto" alt="">
            </div>

          </div>
          <div class="product-swiper-button-prev" @click="prevSlide3"></div>
          <div class="product-swiper-button-next" @click="nextSlide3"></div>
          <!-- <div class="ymf-text">
            <h6>怡满分杭州万象城店</h6>
            <address>浙江省杭州市上城区四季青街道富春路701号杭州万象城L507号商铺</address>
          </div>
          <div class="ymf-text">
            <h6>怡满分杭州大厦501店</h6>
            <address>浙江省杭州市上城区景昙路9号西子国际中心(杭州大厦 501 城市广场)一 楼 101-14、101-15 店铺</address>
          </div> -->
        </div>
      </div>
    </div>

    <div class="shicai">
      <img v-if="$isMobile" src="https://outin-659b005a2fad11f083ad00163e1c94a4.oss-cn-shanghai.aliyuncs.com/image/default/01D4B57ED9664F5E8CA4F6AE444C5FB4-6-2.jpg" width="100%"
        height="auto" alt="满分食材">
      <div class="md-container">
        <div class="shicai-til">
          <h3>满分食材</h3>
        </div>

        <p class="shicai-desc">
          每一口，<br /> 都是满分食材 的用心答卷。
        </p>
        <ul class="ymf-text">
          <li>
            <p>精选莲子</p>
          </li>
          <li>
            <p>殿堂级桃胶</p>
          </li>
          <li>
            <p>精选银耳</p>
          </li>
          <li>
            <p>精选芋头</p>
          </li>
          <li>
            <p>殿堂级黑米</p>
          </li>
          <li>
            <p>殿堂级红豆</p>
          </li>
        </ul>
      </div>
    </div>

    <div class="cailiao">
      <img v-if="$isMobile" src="https://outin-659b005a2fad11f083ad00163e1c94a4.oss-cn-shanghai.aliyuncs.com/image/default/6025F3A70F9F4D39A89A31A05D5A6A35-6-2.jpg" height="auto"
        width="100%" alt="满分食材">
      <template v-else>
        <img src="https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/cailiao_01.jpg" height="auto" width="100%"
          alt="满分食材">
        <img src="https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/cailiao_02.jpg" height="auto" width="100%"
          alt="满分食材">
      </template>
    </div>
    <div class="pinpai">
      <img v-if="$isMobile" src="https://outin-659b005a2fad11f083ad00163e1c94a4.oss-cn-shanghai.aliyuncs.com/image/default/13282F57DA2F439A89EC01611E3F6B5C-6-2.jpg" height="auto"
        width="100%" alt="手作糖水">
      <template v-else>
        <img src="https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/image_01.jpg" height="auto" width="100%"
          alt="手作糖水">
        <img src="https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/image_02.jpg" height="auto" width="100%"
          alt="手作糖水">
        <img src="https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/image_03.jpg" height="auto" width="100%"
          alt="手作糖水">
      </template>

    </div>


    <Foot></Foot>

  </div>


</template>
<script>
import Swiper from "swiper";
import Foot from "../components/Foot.vue";
import FoldNav from "../components/FoldNav.vue";
export default {
  components: {
    Foot,
    FoldNav
  },
  data() {
    return {
      currentIndex: 0,
      slideLength: 0,
      currentIndex2: 0,
      isVideoEnd: false,
      showFocusImage: false
    };
  },
  computed: {
    storeList() {
      return this.$isMobile ? this.$globalData.store_home_m : this.$globalData.store_home;
    },
    isHarmonyOS() {
      const ua = navigator.userAgent.toLowerCase();
      return ua.indexOf('huaweihbp') > -1 || ua.indexOf('hbp-al00') > -1;
    },
    infoList() {
      const infoList = this.$isMobile ? this.$globalData.info.map(item => {
        const _date = item.date;
        const _dateArr = _date.split('-');
        return {
          ...item,
          date: _dateArr[1] + '-' + _dateArr[2]
        }
      }) : this.$globalData.info;
      if (infoList ?.length > 8) {
        return infoList.slice(0, 8);
      }
      return infoList
    },
    moreProducts() {
      return this.$isMobile ? this.$globalData.more_products.m : this.$globalData.more_products.pc;
    },
    newProducts() {
      return this.$isMobile ? this.$globalData.new_products.m : this.$globalData.new_products.pc;
    },
    videoSrc() {
      return this.$isMobile ? this.$globalData.mVideo : this.$globalData.video1
    },
    videoBgSrc() {
      return this.$globalData.video2
    }
  },
  methods: {
    prevSlide() {
      this.swiper.slidePrev();
    },
    nextSlide() {
      this.swiper.slideNext();
    },
    prevSlide2() {
      this.swiper2.slidePrev();
    },
    nextSlide2() {
      this.swiper2.slideNext();
    },
    prevSlide3() {
      this.swiper3.slidePrev();
    },
    nextSlide3() {
      this.swiper3.slideNext();
    },
    videoCanPlay() {
      console.log("videoLoaded");
      this.videPlay();
    },
    videPlay() {
      this.video.play();
    },
    videoEnd() {
      console.log("video---end");
      this.isVideoEnd = true
    },
    setupX5Video() {
      const self = this;
      // 监听X5内核准备就绪事件
      document.addEventListener("x5videoinit", function () {
        if (self.video) {
          self.video.play().catch(() => console.log('X5 autoplay blocked'));
        }
        self.video2.play().catch(() => console.log('X5 autoplay blocked'));
      });

      // 设置X5视频参数
      if (self.video) {
        self.video.setAttribute('x5-video-player-type', 'h5');
        self.video.setAttribute('x5-video-orientation', 'portrait');
      }
      self.video2.setAttribute('x5-video-player-type', 'h5');
      self.video2.setAttribute('x5-video-orientation', 'portrait');
    },
    handleAutoplay() {
      const self = this;
      if (self.video) {
        const playPromise = self.video.play();
        if (playPromise !== undefined) {
          playPromise.catch(() => {
            // 如果自动播放失败，添加触摸事件监听
            document.addEventListener('touchstart', () => {
              self.video.play();
            }, { once: true });
          });
        }
      }
      const playPromise2 = self.video2.play();

      if (playPromise2 !== undefined) {
        playPromise2.catch(() => {
          // 如果自动播放失败，添加触摸事件监听
          document.addEventListener('touchstart', () => {
            self.video2.play();
          }, { once: true });
        });
      }
    },
    autoWxPlayVideo() {
      const self = this;
      if (window.WeixinJSBridge) {
        window.WeixinJSBridge.invoke(
          "getNetworkType",
          {},
          function () {
            self.setupX5Video();
            self.handleAutoplay();
          });
      } else {
        document.addEventListener(
          "WeixinJSBridgeReady",
          function () {
            self.setupX5Video();
            self.handleAutoplay();
          });
      }
    },
    preLoadVideo() {
      // 微信环境
      if (navigator.userAgent.toLowerCase().indexOf("micromessenger") > -1) {
        this.autoWxPlayVideo();
      } else {
        //非微信环境
        try {
          this.handleAutoplay();
        } catch (error) {
          console.log(error);
          this.showFocusImage = true;
        }
      }
    },
  },
  watch:{
    isHarmonyOS:{
      immediate: true,
      handler(v){
        if(v){
          this.showFocusImage = true;
        }
      }
    }
  },
  mounted() {
    const that = this;
    const videoClassName = ".focus-video";
    this.video = document.querySelector(videoClassName);
    this.video2 = document.querySelector(".bg-video");
    if (this.video) {
      this.video.addEventListener("canplay", this.videoCanPlay, true);
      this.video.addEventListener("ended", this.videoEnd, true);
    }

    this.preLoadVideo();
    this.swiper = new Swiper(".new-product-swiper", {
      grabCursor: true,
      on: {
        transitionEnd: function (swiper) {
          that.currentIndex = swiper.realIndex
        },
        init(mySwiper) {
          that.slideLength = mySwiper.slides.length;
        }
      }
    });

    this.swiper2 = new Swiper(".more-product-swiper", {
      grabCursor: true,
      on: {
        transitionEnd: function (swiper) {
          that.currentIndex2 = swiper.realIndex
        }
      }
    });
    this.swiper3 = new Swiper(".store-swiper", {
      preventClicks: true,
      loop: true,
    });

  },
  beforeCreate() {

  },
  destroyed() {
    if (this.video) {
      this.video.removeEventListener("canplay", this.videoCanPlay, true);
      this.video.removeEventListener("ended", this.videoEnd, true);
      this.video = null;
    }

  },
};
</script>
<style lang="less" scoped>
@import "../lib/px2vw";

.focus-img {
  object-fit: cover;
}

@media(max-width: 1200px) {
  .ymf-wrapper {
    .t-scroll {
      width: (67 / @base ) !important;
      height: (57 / @base ) !important;
      left: (80 / @base) !important
    }

    .liaojie {
      height: 177.86667vw !important;

      .md-container {
        height: 100% !important;
        width: 100% !important;

        .text-wrapper {
          width: 81.46667vw !important;
          height: 73.6667vw !important;
          left: 50% !important;
          transform: translateX(-50%);
          top: (200 / @base) !important;
          background-size: 100%;

        }

        a {
          width: 30vw !important;
          height: 9.066667vw !important;
          bottom: 12.53333vw !important;
          left: 9.3333vw !important;
        }
      }
    }

    .new-product {
      width: 100%;

      .out-swiper-wraper {
        display: flex;
        justify-content: center;
      }

      .swiper {
        width: 100%;
        flex-shrink: 0;

        .swiper-button-prev,
        .swiper-button-next {
          width: 10.8vw !important;
          height: 10.9vw !important;
          background-size: 100% auto;
          top: 10.8vw !important;
          transform: translate(0) !important;
          display: none !important;
        }

        .swiper-button-prev {
          left: 9.3333vw !important;
        }

        .swiper-button-next {
          right: 9.3333vw !important;
          transform: rotate(180deg) translate(0) !important;
        }

        .swiper-pagination {
          bottom: 5.6vw !important;
          gap: 1.333vw !important;
          right: 9.333vw !important;

          span {
            width: 2vw !important;
            height: 2vw !important;
            margin: 0 !important;
          }
        }

        .swiper-slide {
          width: 100%;

        }
      }
    }

    .more-product {
      a.go-more-product {
        display: none !important;
      }


      .swiper {
        position: relative;

        .swiper-pagination {
          position: absolute;
          display: flex;
          bottom: 5.6vw !important;
          gap: 1.333vw !important;
          right: 9.333vw !important;

          span {
            width: 2vw !important;
            height: 2vw !important;
            margin: 0 !important;
            background: #bba273;
            border-radius: 50%;

            &.active {
              background: #93691e;
            }
          }
        }

        .product-swiper-button-prev,
        .product-swiper-button-next {
          width: 10.8vw !important;
          height: 10.9vw !important;
          background-size: 100% auto;
          display: none !important;
        }

      }
    }

    .info {
      .info-box {
        width: 25.8667vw !important;
        right: 9.3333vw !important;
        transform: translateY(0) !important;
        padding-top: 2.88vw;
        top: 112.667vw !important;

        a.more-btn {
          width:100% !important;
          height: 12.39vw !important;
          background-size: 100% auto !important;
          margin: 8vw auto 0 auto !important;
        }

        .t-line {
          height: 1px !important;
        }

        h3 {
          font-size: 6.70667vw !important;
          line-height: 6.70667vw !important;
          margin-bottom: 3.2vw !important;
        }

        .info-list {
          height: 58.88vw !important;
          padding: 1.08vw 0 !important;
          height: 28.6777vw !important;

          a {
            font-size: 2.7893vw !important;
            line-height: 3.4667vw !important;
            .til{
              width: 21.333vw !important;
            }
          }
        }
      }
    }

    .store {
      h3 {
        display: none;
      }

      .swiper {

        .product-swiper-button-prev,
        .product-swiper-button-next {
          width: 10.8vw !important;
          height: 10.9vw !important;
          background-size: 100% auto;
          bottom: 0 !important;
          display: none;
        }

        .product-swiper-button-next {
          right: 5.8vw !important;
        }

        .product-swiper-button-prev {
          left: 5.8vw !important;
        }
      }
    }

    .shicai {
      height: auto !important;
      background: none !important;
      position: relative;

      .md-container {
        position: absolute;
        width: 100% !important;
        height: 100% !important;
        left: 0;
        top: 0;
        display: none;
      }

      .shicai-til {
        top: 50%;
        transform: translateY(-50%);
        background-size: 15.5vw auto;
        width: 37.6vw !important;
        left: 2.88vw !important;

        h3 {
          font-size: 14.8vw !important;
          line-height: 14.8vw !important;
          height: 78.28vw !important;
        }
      }

      .shicai-desc {
        font-size: 7.2vw !important;
        line-height: 8.8vw !important;
        right: 1.88vw !important;
        height: 64.8vw !important;
        right: 2.88vw !important;
      }
    }

    .huiyi-wrapper {
      width: 100%;
      height: auto;
      position: relative;
      overflow: hidden;
      display: flex;
      justify-content: flex-end;
      flex-wrap: nowrap;


      .huiyi {
        flex-shrink: 0;
        width: 100vw !important;

        .md-container {
          position: absolute;
          width: 100vw !important;
          height: 100% !important;
          right: 0 !important;
          top: 0 !important;
          transform: translate(0, 0) !important;
          left: inherit !important;

          .left-text {
            width: 19.6vw !important;
            height: 60.93333vw !important;
            background-size: 100% auto !important;
            left: 9.333vw !important;
            top: 24vw !important;
            background: url(https://outin-659b005a2fad11f083ad00163e1c94a4.oss-cn-shanghai.aliyuncs.com/image/default/97875AA56DAB46C8ADDB41DDB7DE18A4-6-2.png) no-repeat top center !important;
            background-size: 100% auto !important;

          }

          b {
            width: 23.2vw !important;
            height: 7.6274vw !important;
            left: 9.333vw !important;
            bottom: 16.53333vw !important;
          }
        }

        .right-text {
          display: none !important;
        }
      }
    }


  }



}

.ymf-wrapper {
  background: #d2c4b5;
  width: 100%;
}

@media(max-width: 1560px) {
  .huiyi {
    .left-text {
      transform: scale(0.8) !important;
      top: 100px !important;
      transform-origin: 0 0;
    }

    .right-text {
      top: 90px !important;
    }
  }

  .more-product {
    .product-swiper-button-prev {
      left: 40px !important;
      transform: scale(0.8) translateY(-50%) !important;

    }

    .product-swiper-button-next {
      right: 40px !important;
      transform: scale(0.8) rotate(180deg) translateY(50%) !important;
    }
  }

}

@media(max-width: 1300px) {
  .huiyi {
    .left-text {
      transform: scale(0.7) !important;
      top: 100px !important;
      transform-origin: 0 0;
    }

    .right-text {
      top: 100px !important;
    }
  }

  .more-product {
    .product-swiper-button-prev {
      left: 10px !important;
      transform: scale(0.8) translateY(-50%) !important;

    }

    .product-swiper-button-next {
      right: 10px !important;
      transform: scale(0.8) rotate(180deg) translateY(50%) !important;
    }
  }

}

.focus-wrap {
  width: 100%;
  height: 100vh;

  position: relative;

  .focus-video {
    object-fit: cover;
    width: 100vw;
  }

  .focus-title {
    position: absolute;
    width: 534px;
    height: 710px;
    background: url(https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/index_text.png) no-repeat top center;
    background-size: 100%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .t-logo {
    position: absolute;
    background: url(https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/logo.png) no-repeat top center;
    background-size: 100%;
    width: 82px;
    height: 82px;
    bottom: 43px;
    left: 50%;
    transform: translateX(-50%)
  }

  .t-scroll {
    position: absolute;
    width: 67px;
    height: 57px;
    background: url(https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/scroll.png) no-repeat top center;
    background-size: 100%;
    left: 100px;
    bottom: 0;
  }


  .t-more {
    position: absolute;
    background: url(https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/more_icon.png) no-repeat top center;
    width: 60px;
    height: 29px;
    right: 100px;
    top: 60px;
    cursor: pointer;
  }
}

.new-product {
  width: 100%;
  overflow: hidden;

  .swiper {
    position: relative;
    overflow: hidden;
    width: 100%;

    // height: 100%;
    .swiper-button-prev,
    .swiper-button-next {
      position: absolute;
      width: 94px;
      height: 95px;
      background: url("https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/slide_btn.png") no-repeat top center;
      background-size: 100%;
      top: 50%;
      cursor: pointer;
    }

    .swiper-button-prev {
      left: 100px;
      transform: translateY(-50%);
    }

    .swiper-button-next {
      right: 100px;
      transform: rotate(180deg) translateY(50%);
    }

    .swiper-pagination {
      display: flex;
      position: absolute;
      bottom: 54px;
      right: 420px;

      span {
        width: 24px;
        height: 24px;
        background: #bba273;
        border-radius: 50%;
        margin: 0 7px;

        &.active {
          background: #93691e;
        }
      }
    }
  }

  .swiper-wrapper {
    width: 1000%;
    display: flex;
    flex-wrap: nowrap;

    .swiper-slide {
      width: 100vw;
      height: auto;
      position: relative;
    }
  }
}

.liaojie {
  position: relative;
  width: 100%;
  height: 1207px;

  .md-container {
    height: 1207px;
  }

  .bg-video {
    object-fit: cover;
    width: 100vw;
  }


  .md-container {
    font-family: hanli-min, hanli;
    position: absolute;
    left: 50%;
    top: 0;
    transform: translateX(-50%);

    .text-wrapper {
      position: absolute;
      left: 0;
      top: 286px;
      background: url(https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/home_text_01.png) no-repeat top center;
      width: 685px;
      height: 567px;
      // top: 50%;
      // transform: translateY(-50%);
    }

    a {
      position: absolute;
      width: 225px;
      height: 68px;
      background: url("https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/1341745906219_.png") no-repeat top center;
      background-size: 100%;
      left: 91px;
      bottom: 176px;
    }

    h3 {
      font-weight: lighter;
      font-size: 38px;
      color: #ffffff;
      text-align: left;
      line-height: 40px;
      padding-left: 80px;
    }

    p {
      width: 720px;
      font-size: 38px;
      color: #ffffff;
      text-align: left;
      line-height: 41px;
      margin-top: 40px;
      text-indent: 80px;
    }
  }
}

.huiyi {
  position: relative;
  width: 100%;
  height: auto;
  font-family: hanli-min, hanli;

  .md-container {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    b {
      position: absolute;
      background: url(https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/text_01.png) no-repeat top center;
      width: 292px;
      height: 96px;
      background-size: 100% 100%;
      left: 0;
      bottom: 203px;
    }
  }

  .left-text {
    left: 0;
    top: 266px;
    position: absolute;
    background: url(https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/home_text_02.png) no-repeat top center;
    width: 355px;
    height: 1113px;
  }


  .right-text {
    position: absolute;
    top: 303px;
    right: 100px;
    background: url(https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/home_text_03.png) no-repeat top center;
    width: 60px;
    height: 918px;
  }


  .right-text {
    right: 100px;
  }
}


.more-product {
  position: relative;
  width: 100%;
  height: auto;
  overflow: hidden;

  a.go-more-product {
    position: absolute;
    width: 179px;
    height: 55px;
    background: url("https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/more_product_btn.png") no-repeat top center;
    background-size: 100%;
    left: 100px;
    top: 132px;
    cursor: pointer;

    &:hover {
      cursor: pointer;
    }
  }

  .product-swiper-button-prev,
  .product-swiper-button-next {
    position: absolute;
    width: 94px;
    height: 95px;
    background: url("https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/more_product_left.png") no-repeat top center;
    background-size: 100%;
    top: 50%;
    cursor: pointer;
  }

  .product-swiper-button-prev {
    left: 100px;
    transform: translateY(-50%);
  }

  .product-swiper-button-next {
    right: 100px;
    transform: rotate(180deg) translateY(50%);
  }

  .swiper {
    overflow: hidden;
    width: 100%;
    position: relative;

    .swiper-wrapper {
      display: flex;
      flex-wrap: nowrap;
      width: 1000%;

      .swiper-slide {
        width: 100vw;
        height: auto;
        position: relative;
      }

    }
  }
}

.pinpai {
  position: relative;

}

.info {
  position: relative;
  width: 100%;

  .md-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;

    .info-box {
      position: absolute;
      right: 100px;
      top: 50%;
      transform: translateY(-50%);
      width: 312px;
      font-family: hanli-min, HL0811,Hl0906,Hl1126;
      color: #d1b584;

      .t-line {
        display: block;
        width: 100%;
        height: 2px;
        background: #d1b584;
      }

      h3 {
        font-size: 80px;
        color: #d1b584;
        line-height: 80px;
        font-weight: normal;
        margin: 0;
        padding: 0;
        letter-spacing: -3px;
        margin-bottom: 46px;
      }

      .info-list {
        list-style: none;
        margin: 0;
        padding: 14px 0;
        height: 340px;
        overflow: hidden;

        li {
          margin: 0;
          padding: 0;
        }

        a {
          color: #d1b584;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 34px;
          line-height: 40px;

          .til {
            display: block;
            width: 220px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            text-align: left;
          }
        }
      }

      .more-btn {
        display: block;
        background: url("https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/info_more_btn.png") no-repeat top center;
        width: 309px;
        height: 84px;
        margin-top: 99px;
      }
    }


  }
}

.shicai {
  width: 100%;
  background: url(https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/bg_01.webp) no-repeat top center;
  background-size: cover;
  height: 507px;
  font-family: hanli-min, hanli;
  color: #d1b584;

  .shicai-til {
    background: url(https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/text.png) no-repeat;
    background-position: top 30px right;
    position: absolute;
    width: 224px;
    left: 0;
    top: 50%;
    transform: translateY(-50%);

    h3 {
      font-size: 105px;
      line-height: 104px;
      font-weight: lighter;
      writing-mode: vertical-rl;
      -webkit-writing-mode: vertical-rl;
      text-orientation: upright;
    }
  }

  .shicai-desc {
    position: absolute;
    font-size: 50px;
    line-height: 54px;
    writing-mode: vertical-rl;
    -webkit-writing-mode: vertical-rl;
    text-orientation: upright;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    text-align: start;
    height: 366px;
  }

}

.store {
  width: 100%;
  overflow: hidden;
  position: relative;

  h3 {
    position: absolute;
    font-size: 114px;
    line-height: 116px;
    color: #d1b584;
    writing-mode: vertical-lr;
    z-index: 1;
    font-family: hanli-min, hanli;
    font-weight: normal;
    right: 100px;
    top: 90px;
    margin: 0;
    padding: 0;

  }

  .swiper {
    overflow: initial;
    width: 100%;

    .product-swiper-button-prev,
    .product-swiper-button-next {
      position: absolute;
      width: 94px;
      height: 95px;
      background: url("https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/left.png") no-repeat top center;
      background-size: 100%;
      bottom: 44px;
      cursor: pointer;
    }

    .product-swiper-button-prev {
      left: 100px;
      transform: translateY(-50%);
    }

    .product-swiper-button-next {
      right: 100px;
      transform: rotate(180deg) translateY(50%);
    }

    .swiper-wrapper {
      display: flex;
      flex-wrap: nowrap;
      width: 18000%;

      .swiper-slide {
        width: 100%;
        position: relative;

        img {
          width: 100%;
          display: block;
          height: auto;
        }
      }

    }
  }

}
</style>
